import { useReadingGoals } from '../ctx/reading_goals'
import { useStats } from '../ctx/stats'

export const useReadingGoalPermission = () => {
  const isPlusUser = useStats((s) => s.isPlusUser)
  const period = useReadingGoals((s) => s.period)
  const isLockedPeriod = period === 'week' || period === 'month'
  const isLocked = !isPlusUser && isLockedPeriod

  return { isLocked, isLockedPeriod }
}
